module.exports = __webpack_public_path__ + "img/failure.db2ed9c1.svg";